import { getLogger } from "@expert/logging";
import { getSelectedSessionId } from "@/sdk";
import { getSalesApiClient } from "./api";

const logger = getLogger({
    module: "addressSuggestions",
    supportTeam: "sales",
});

export const fetchAddressSuggestions = async (searchText: string) => {
    const childLogger = logger.child({ sessionId: getSelectedSessionId() });
    if (searchText.length < 6) return [];
    try {
        const salesApi = getSalesApiClient();
        const sanitizedSearchText = encodeURIComponent(searchText);
        const addresses = await salesApi.get(`v1/address-autocomplete?text=${sanitizedSearchText}`).json<string[]>();

        return Array.from(new Set(addresses));
    } catch (err: unknown) {
        childLogger.error({ err }, "addressSuggestions failure");
        throw err;
    }
};
